















































  import { Component, Vue, Prop } from 'nuxt-property-decorator'
  import { CombinedFilters, FilteringAttributeType } from '@one/types'
  import { Watch } from 'vue-property-decorator'

  @Component
  export default class OneSelectedFilters extends Vue {
    name: string = 'OneSelectedFilters.vue'

    @Prop({
      type: Object,
      required: true,
    })
    readonly filters!: Record<string, CombinedFilters>;

    @Prop({
      type: Object,
      required: false,
      default: () => ({}),
    })
    readonly selectedFilters!: Record<string, Array<string>>;

    @Prop({
      type: String,
      required: false,
      default: null,
    })
    readonly priceFilter!: string | null;

    @Prop({
      type: Boolean,
      required: false,
      default: false,
    })
    readonly isBrandView!: boolean;

    lockedFilterKeys: Array<string> = ['brand', 'productSeries']

    oldFilters: Record<string, CombinedFilters> = {}

    @Watch('filters', { immediate: true })
    saveOldFilters(_, oldFilters: Record<string, CombinedFilters>) {
      this.oldFilters = oldFilters
    }

    get hasAttributes() {
      if (this.priceFilter) { return true }
      const selectedKeys = Object.keys(this.selectedFilters || {})
        .filter(key => (this.selectedFilters[key] || []).length > 0)
      return selectedKeys.some(key => !this.isFilterLocked(key))
    }

    get hasFilters() {
      return this.filters && Object.keys(this.filters).length || this.oldFilters && Object.keys(this.oldFilters).length
    }

    get priceFilterSimple() {
      // remove GROSS: || NET:
      return this.priceFilter?.split(':')[1]
    }

    getFilterName(key: string): string | null {
      return (this.filters && this.filters[key]?.name) || (this.oldFilters && this.oldFilters[key]?.name) || null
    }

    getFilterType(key: string): string | null {
      return (this.filters && this.filters[key]?.type) || (this.oldFilters && this.oldFilters[key]?.type) || null
    }

    getFilterAttributeLabel(key: string, attrKey: string) {
      return (this.filters && this.filters[key]?.items[attrKey]?.label) || (this.oldFilters && this.oldFilters[key]?.items[attrKey]?.label) || null
    }

    getFilterRangeLabel(key: string) {
      return this.selectedFilters[key]?.[0]
    }

    onAttributeClick(attribute: string, attributeItem: string) {
      if (this.isFilterLocked(attribute)) { return }
      this.$emit('filter-changed', {
        type: this.getFilterType(attribute) as FilteringAttributeType,
        isSelected: false,
        filterValue: attributeItem,
        nameCode: attribute,
      })
    }

    isFilterLocked(key: string): boolean {
      return this.isBrandView && this.lockedFilterKeys.includes(key)
    }

    get canClearFilters(): boolean {
      if (this.priceFilter) { return true }
      const selectedKeys = Object.keys(this.selectedFilters || {})
        .filter(key => (this.selectedFilters[key] || []).length > 0)
      if (!selectedKeys.length) { return false }
      return selectedKeys.some(key => !this.isFilterLocked(key))
    }

    onClearFiltersClick() {
      if (!this.canClearFilters) { return }
      this.$emit('clear-filters')
    }
  }
